import { styled } from '@mui/material';
import Dialog, { dialogClasses, DialogProps } from '@mui/material/Dialog';

export type PrimaryDialogProps = DialogProps;
export function PrimaryDialog({ ...props }: DialogProps) {
  return <DialogStyled {...props} />;
}

const DialogStyled = styled(Dialog)(({ theme }) => ({
  [`& .${dialogClasses.paper}`]: {
    backgroundColor: `color-mix(in srgb, #fff 100%, ${theme.palette.primary.main} 8%)`,
  },
}));
